module.exports = __webpack_public_path__ + "img/bank_img1.15054bb9.png";